import { Outlet } from "@tanstack/react-router";
import { InterfaceWelcome } from "@/components/studio/InterfaceChoice";
import { StudioLayout } from "@/components/studio/StudioLayout";
import { useUser } from "@/hooks/useAuth";
import { useInterfaceLayout } from "@/hooks/useInterfaceLayout";
import "@/components/studio/studio.css";
import { useThemeSync } from "@/hooks/useTheme";
import { MobileSidebarOverlay } from "./MobileSidebarOverlay";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export function DashboardLayout() {
  useThemeSync();
  const { layout, isError, refetch } = useInterfaceLayout();
  const user = useUser();
  const welcome = <InterfaceWelcome key={user?.id} />;
  if (layout === "studio") {
    return (
      <>
        <StudioLayout>
          <Outlet />
        </StudioLayout>
        {welcome}
      </>
    );
  }

  return (
    <>
      <div className="flex h-screen overflow-hidden bg-subtle">
        <Sidebar />
        <MobileSidebarOverlay />

        <div className="flex flex-1 flex-col overflow-hidden">
          <Topbar />

          <main
            className="flex-1 overflow-y-auto px-4 py-6 sm:px-6 lg:px-8 lg:py-8"
            style={{ scrollbarGutter: "stable" }}
          >
            {isError && (
              <div
                role="status"
                className="mb-4 rounded-lg border border-edge bg-panel p-3 text-sm text-dim"
              >
                Nie udało się wczytać preferencji wyglądu.{" "}
                <button
                  type="button"
                  className="underline"
                  onClick={() => void refetch()}
                >
                  Spróbuj ponownie
                </button>
              </div>
            )}
            <Outlet />
          </main>
        </div>
      </div>
      {welcome}
    </>
  );
}
